import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { disableMiddlewareSMO } from '@api/middlewareSMO';

import { IMiddlewareSMO } from '@interfaces/middlewareSMO/middlewareSMO';

import { ESnackbarTypes } from '@enums/common';

import { MIDDLEWARE_SMO_DISABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareSMODisableProps {
	handleCloseModal: () => void;
	middleware: IMiddlewareSMO | null;
}

interface IUseMutateMiddlewareSMODisableReturned {
	disableMiddlewareSMO: (id: string) => void;
	isLoadingDisableMiddlewareSMO: boolean;
}

const useMutateMiddlewareSMODisable = ({
	handleCloseModal,
	middleware,
}: IUseMutateMiddlewareSMODisableProps): IUseMutateMiddlewareSMODisableReturned => {
	const dispatch = useAppDispatch();
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [MIDDLEWARE_SMO_DISABLE],
		mutationFn: disableMiddlewareSMO,
		onSuccess: () => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.middlewareDeactivated(middleware?.systemId),
				type: ESnackbarTypes.success,
			}));

			return invalidateMiddlewareSMO();
		},
	});

	return {
		disableMiddlewareSMO: mutate,
		isLoadingDisableMiddlewareSMO: isLoading,
	};
};

export default useMutateMiddlewareSMODisable;
